import config from 'config/config';

export default {
  // Pred a link for insertion into anchor href
  prepLink(link: string) {
    if (!link) return '';

    if (link.indexOf('//') > -1) {
      return link;
    }

    return 'http://' + link;
  },

  generateAvatarLinkFromHash(hash = '') {
    return !hash
      ? config.defaultProfileImage
      : config.cdn.avatars + hash + config.avatars.smallSuffix;
  },

  generateAvatarLink(user: {
    id?: number;
    imageUrl?: string;
    isDeleted: boolean;
    profileImageSmall?: string;
    userId?: number;
    userImageHash?: string;
  }) {
    if (!user || user.isDeleted || (!user.userId && !user.id)) {
      return config.defaultProfileImage;
    }

    return user.imageUrl
      || user.profileImageSmall
      || (config.cdn.avatars + user.userImageHash + config.avatars.smallSuffix);
  },

  generatePromoImageLink(hash: string) {
    return `${config.cdn.communityPromoImages}${hash}_378x378.jpg`;
  },

  generateReplyPreviewImageUrlFromHash(hash: string) {
    return `${config.cdn.replyImg}response_preview_${hash}.jpg`;
  },
};

export function getCommunityLogoUrl(logoImageHash?: string, useSmall = false) {
  if (!logoImageHash) return config.defaultCommunityImage;
  const suffix = useSmall ? config.groups.logoSuffixSmall : config.groups.logoSuffix;
  return config.cdn.communityLogos + logoImageHash + suffix;
}

export function getCommunityBannerUrl(bannerImageHash?: string, useSmall = false) {
  if (!bannerImageHash) return '';
  const suffix = useSmall ? config.groups.bannerSuffixSmall : config.groups.bannerSuffix;
  return config.cdn.communityBanners + bannerImageHash + suffix;
}
